import { TFNReverificationModalType } from './types';

export const buildVerificationMailto = (
  shopName: string,
  firstName = shopName,
): string => {
  const encodedShopName = encodeURIComponent(shopName);
  const encodedFirstName = encodeURIComponent(firstName);
  return `mailto:verifications@postscript.io?subject=TFN%20verification%20status%20update%20request%20from%20${encodedShopName}&body=Hello%20Postscript%2C%0D%0A%0D%0AWhat%E2%80%99s%20the%20toll-free%20number%20(TFN)%20verification%20status%20for%20${encodedShopName}%3F%0D%0A%0D%0AThanks!%20%0D%0A${encodedFirstName}`;
};

const TFN_REJECTION_CODE_TO_MODAL: Record<number, TFNReverificationModalType> =
  {
    30527: TFNReverificationModalType.INVALID_BUSINESS_REGISTRATION,
    30482: TFNReverificationModalType.INVALID_BUSINESS_EMAIL,
    30452: TFNReverificationModalType.INVALID_BUSINESS_EMAIL,
    30489: TFNReverificationModalType.UNREACHABLE_WEBSITE,
    30473: TFNReverificationModalType.UNREACHABLE_WEBSITE,
    30491: TFNReverificationModalType.PASSWORD_PROTECTED_WEBSITE,
    30483: TFNReverificationModalType.INVALID_CONTACT,
    30484: TFNReverificationModalType.INVALID_CONTACT,
    30451: TFNReverificationModalType.INVALID_ADDRESS,
    30445: TFNReverificationModalType.INVALID_BUSINESS_INFO,
  };

export function getTFNReverificationModalType(
  rejectionCode: number | null | undefined,
): TFNReverificationModalType {
  if (rejectionCode == null) {
    return TFNReverificationModalType.UNKNOWN;
  }

  return (
    TFN_REJECTION_CODE_TO_MODAL[rejectionCode] ??
    TFNReverificationModalType.UNKNOWN
  );
}

const RESUBMISSION_MODAL_TYPES = new Set<TFNReverificationModalType>([
  TFNReverificationModalType.UNREACHABLE_WEBSITE,
  TFNReverificationModalType.PASSWORD_PROTECTED_WEBSITE,
  TFNReverificationModalType.INVALID_BUSINESS_EMAIL,
  TFNReverificationModalType.INVALID_CONTACT,
  TFNReverificationModalType.INVALID_ADDRESS,
  TFNReverificationModalType.INVALID_BUSINESS_REGISTRATION,
  TFNReverificationModalType.INVALID_BUSINESS_INFO,
]);

export function isEligibleForResubmission(
  rejectionCode: number | null | undefined,
): boolean {
  const modalType = getTFNReverificationModalType(rejectionCode);
  return RESUBMISSION_MODAL_TYPES.has(modalType);
}
